import { TableContent } from '../../../Common/Table/tableContent';
import React, { useEffect, useState, Fragment, useRef } from "react";
import { TableContentWithoutEdit } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {



    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;   
        const searchData = this.props.searchData;
        const initialData = this.props.initialData;
        const groups = this.props.groupData;
        const operationEntity = this.props.operationEntityData;



        return (
            <div>
                <h3><center><u>Leaf Collection Overview Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {initialData.groupID}</div>
                    <div className="col"><b>Operation Entity: </b> {initialData.operationEntityID}</div>
                    <div className="col"><b>Date: </b> {initialData.startDate}</div>
                    {/* <div className="col"><b>End Date: </b> {initialData.endDate}</div> */}



                </div>
                <div className="row alternative_cls">
                    <div className="col pb-2 width4">
                        <table className="display dataTable no-footer">
                            <thead>
                            <tr>
                              <th rowSpan="2">Route Name</th>
                              <th rowSpan="2">Route ID</th>
                              <th rowSpan="2">Start Time</th>
                              <th rowSpan="2">End Time</th>
                              <th rowSpan="2">Gross Amount</th>
                              <th rowSpan="2">Tag Count</th>
                              <th rowSpan="2">Supplier Count</th>
                            </tr>
                            </thead>
                            <tbody>
                                <TableContentWithoutEdit
                                    data={data}
                                    contentRowNames={rowNames}
                                    hasEdit={false}
                                />
                            </tbody>
                        </table>
                    </div>
                    <hr />
                </div>
            </div>
        );
    }
}